"use client";
import React from "react";
import "./NetworkCarousel.css";
import { useLanguage } from "../i18n/LanguageContext";

// Put your SVG filenames here – they live in public/networks
const NETWORK_LOGOS = [
    "b1d593a27d5b01315d51.svg",
    "3d9e8807d8e97ec018c4.svg",
    "15d30ed5bd796f3973a8.svg",
    "896f1c98e6b31047dffa.svg",
    "a6267b3c2154f203aefb.svg",
    "acba43cf2ce2ff0290f3.svg",
];

export default function NetworkCarousel() {
    const { t } = useLanguage();
    const items = NETWORK_LOGOS.map((file) => ({
        name: file.replace(".svg", "").toUpperCase(),
        logo: `/networks/${file}`,
    }));

    const logos = [...items, ...items, ...items]

    if (!items.length) return null;

    return (
        <div className="network-carousel">
            <p className="network-carousel-text">
                {t("home.networkText")}
            </p>

            <div className="network-carousel-pill" aria-label={t("home.networkAria")}>
                <div className="network-carousel-row no-scrollbar">
                    {logos.map((item, i) => (
                        <div key={item.name + i} className="network-carousel-logo">
                            <img src={item.logo} alt={item.name} className="network-carousel-img" loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
